import React, { useState, useEffect } from 'react';
import api from '../../api';

/**
 * MuteButton - Controls AURA's server-side mute status
 * When muted, the /speak endpoint returns silent audio
 * This is separate from browser-level audio muting
 */
const MuteButton = () => {
  const [isMuted, setIsMuted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check mute status on component mount
  useEffect(() => {
    checkMuteStatus();
  }, []);

  const checkMuteStatus = async () => {
    try {
      const response = await api.get('/api/v1/robot/mute-status');
      setIsMuted(response.data.muted || false);
    } catch (error) {
      console.error('Failed to check mute status:', error);
      // Default to unmuted if check fails
      setIsMuted(false);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMute = async () => {
    const newMutedState = !isMuted;
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append('muted', newMutedState.toString());

      const response = await api.post('/api/v1/robot/mute', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setIsMuted(response.data.muted);
      console.log(`🔇 AURA ${response.data.muted ? 'muted' : 'unmuted'}`);
    } catch (error) {
      console.error('Failed to toggle mute:', error);
      // Revert on error
      setIsMuted(!newMutedState);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <button
        className="text-white hover:bg-white/20 p-1 rounded transition-colors"
        title="Loading mute status..."
        disabled
      >
        <svg className="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </button>
    );
  }

  return (
    <button
      onClick={toggleMute}
      className={`text-white hover:bg-white/20 p-1 rounded transition-colors ${
        isMuted ? 'opacity-75' : ''
      }`}
      title={isMuted ? 'Unmute AURA' : 'Mute AURA'}
    >
      {isMuted ? (
        // Muted icon (crossed out speaker)
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2" />
        </svg>
      ) : (
        // Unmuted icon (speaker)
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
        </svg>
      )}
    </button>
  );
};

export default MuteButton;

